/**
 * Identifier key for BP Core store reducer.
 *
 * @type {string}
 */
export const STORE_KEY = 'bp/core';
